/**
 * 导出
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/4/12      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from "react";
import { Button, Modal, Form, Checkbox, DatePicker } from "antd";
import dayjs from "dayjs";
import IconFont from "@components/IconFont/index";
import "./index.less";
import Cookie from "@utils/cookie";
import ExportBtn from '@/components/ExportBtn/index'
const { RangePicker } = DatePicker;
const config = require("../../../../../config/config");
const Locale = require("../../../../utils/locale").default;
let locale = Locale.current();
class Export extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            startTime: "",
            endTime: "",
            isDealBuyer: [],
        };
        this.resetRef = React.createRef();
    }

    /**
     * 展示弹窗
     */
    showModal = () => {
        this.setState({
            isVisible: true,
        });
    };

    /**
     * 导出
     */
    handleOk = () => {
        let {userId} = Cookie.getJSON("fmg.extra") || {};
        let template =
            locale === "ru"
                ? "BuyerUserBehaviorReport_ru"
                : "BuyerUserBehaviorReport_zh";
        let href =
            config.servers[config.environment].exportApi +
            `/data/bpms/jreport/mg/behavior/print?template=${template}&userId=${userId}`;
        //地址拼接，如果没有数据也要拼接
        href += `&startTime=${this.state.startTime || ""}`;
        href += `&endTime=${this.state.endTime || ""}`;
        if (this.state.isDealBuyer && this.state.isDealBuyer.length == 1) {
            href += `&isDealBuyer=${this.state.isDealBuyer.join(",")}`;
        } else {
            href += `&isDealBuyer=`;
        }
        href += "&isCheck=0";

        window.open(href);
        /*this.setState({
            isVisible: false,
        });*/
        this.handleCancel();
    };

    /**
     * 取消
     */
    handleCancel = () => {
        const current = this.resetRef.current;
        this.setState(
            {
                startTime: null,
                endTime: null,
                isDealBuyer: [],
                isVisible: false,
            },
            function () {
                current.resetFields();
            }
        );
    };

    /**
     * 时间回调
     */
    onTimeChange = (dates, dateStrings) => {
        console.log("dates",dates)
        let startTime = "",
            endTime = "";
        if(dates&&dates[0]){
            startTime = dates[0].format("YYYY/MM/DD");
        }
        if(dates&&dates[1]){
            endTime = dates[1].format("YYYY/MM/DD");
        }

        this.setState({
            startTime: startTime ? dayjs(startTime).valueOf() : "",
            endTime: endTime ? dayjs(endTime).valueOf() : "",
        });
    };

    /**
     * 修改选项
     * @param checkedValues
     */
    onChange = (checkedValues) => {
        this.setState({
            isDealBuyer: checkedValues,
        });
    };

    render() {
        const layout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
        };
        const { startTime, endTime } = this.state;
        console.log("dates",startTime,endTime)
        return (
            <span>
                {/*弹窗*/}
                <Modal
                    width={600}
                    title={__getServerLanguage("DaoChuShuJuShaiXuan")}
                    open={this.state.isVisible}
                    okText={__getServerLanguage("DaoChu")}
                    onOk={this.handleOk}
                    cancelText={__getServerLanguage('QuXiao')}
                    onCancel={this.handleCancel}
                >
                    <Form className="export-wrap" {...layout} ref={this.resetRef}>
                        <Form.Item
                            name="time"
                            label={__getServerLanguage("ZuiJinFangWenShiJian")}
                        >
                            <RangePicker
                                placeholder={[__getServerLanguage('KaiShiShiJian'),__getServerLanguage('JieShuShiJian')]}
                                initialValues={[]}
                                onChange={this.onTimeChange}
                            />
                        </Form.Item>

                        <Form.Item
                            {...layout}
                            label={__getServerLanguage("KeHuLeiXing")}
                            name="isDealBuyer"
                            valuePropName="checked"
                        >
                            <Checkbox.Group
                                onChange={this.onChange}
                            >
                                <Checkbox value={0}>
                                    {__getServerLanguage("WeiChengJiaoKeHu")}
                                </Checkbox>

                                <Checkbox value={1}>
                                    {__getServerLanguage("YiChengJiaoDeKeHu")}
                                </Checkbox>

                            </Checkbox.Group>
                        </Form.Item>
                    </Form>
                </Modal>
                {/*按钮*/}
                <ExportBtn onClick={this.showModal.bind(this)} txt={"DaoChu"} authName={this.props.authName}></ExportBtn>
                {/*<Button className="export-btn" onClick={this.showModal}>
                    <IconFont type="icon-export" className="img"></IconFont>
                    <span>{__getServerLanguage("DaoChu")}</span>
                </Button>*/}
            </span>
        );
    }
}

Export.defaultProps = {};

Export.propTypes = {};
export default Export;
